/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { complexDependencies } from './dependenciesComplex.generated.js';
import { conjDependencies } from './dependenciesConj.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { equalDependencies } from './dependenciesEqual.generated.js';
import { identityDependencies } from './dependenciesIdentity.generated.js';
import { isZeroDependencies } from './dependenciesIsZero.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated.js';
import { signDependencies } from './dependenciesSign.generated.js';
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { subtractScalarDependencies } from './dependenciesSubtractScalar.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated.js';
import { zerosDependencies } from './dependenciesZeros.generated.js';
import { createQr } from '../../factoriesAny.js';
export var qrDependencies = {
  addScalarDependencies,
  complexDependencies,
  conjDependencies,
  divideScalarDependencies,
  equalDependencies,
  identityDependencies,
  isZeroDependencies,
  matrixDependencies,
  multiplyScalarDependencies,
  signDependencies,
  sqrtDependencies,
  subtractScalarDependencies,
  typedDependencies,
  unaryMinusDependencies,
  zerosDependencies,
  createQr
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesQr.generated.js
// module id = ySz5
// module chunks = 3